export const API_ROOT = process.env.REACT_APP_API_URL;
export const API_WS_ROOT = process.env.REACT_APP_API_WS_ROOT;

export const HEADERS = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};
